import React, { useState } from 'react';
import appStyle from "./AIAgentBot.module.css";
import RazorpayCheckout from '../RazorpayCheckout';

export default function IngestionStorage({ limit, remaining, totalTopups, isLoading }) {
  const [showTopUpModal, setShowTopUpModal] = useState(false);
  const [topUpAmount, setTopUpAmount] = useState(1500);
  const [topUpSize, setTopUpSize] = useState(250000);

  const totalCapacity = limit + totalTopups;
  const remainingPercentage = totalCapacity > 0 ? (remaining / totalCapacity) * 100 : 0;
  
  const isLow = () => {
    if (totalCapacity === 0) return false;
    return remainingPercentage < 20;
  };
  
  const hasTopups = totalTopups > 0;

  const handleTopUp = () => {
    setShowTopUpModal(true);
  };

  return (
    <>
      <div className={appStyle.creditSection}>
        <h3>📦 Ingestion Storage</h3>
        {isLoading ? (
          <div className={appStyle.loadingState}>
            <span className={appStyle.loadingSpinner}></span>
            <p>Loading storage...</p>
          </div>
        ) : (
          <div className={appStyle.creditsContainer}>
            <div className={appStyle.creditsMain}>
              <span className={appStyle.creditsRemaining}>
                {remaining.toLocaleString()}
              </span>
              <span className={appStyle.creditsLabel}>
                Available Storage (KB)
              </span>
            </div>

            <div className={appStyle.progressBar}>
              <div
                className={appStyle.progressFill}
                style={{ width: `${remainingPercentage}%` }}
              />
            </div>

            <div className={appStyle.capacityInfo}>
              <div className={appStyle.capacityRow}>
                <span>📋 Plan Limit:</span>
                <strong>{limit.toLocaleString()} KB</strong>
              </div>
              {hasTopups && (
                <div className={appStyle.capacityRow}>
                  <span>➕ Top-ups Added:</span>
                  <strong className={appStyle.topupHighlight}>+{totalTopups.toLocaleString()} KB</strong>
                </div>
              )}
              <div className={appStyle.capacityRow}>
                <span>🎯 Total Capacity:</span>
                <strong>{totalCapacity.toLocaleString()} KB</strong>
              </div>
            </div>

            <div className={appStyle.statsNote}>
              💡 <strong>How it works:</strong> This shows your remaining storage space for document ingestion. Each KB of documents uses up storage. Top up to add more capacity beyond your plan limit.
            </div>

            {isLow() && (
              <div className={appStyle.topUpSection}>
                <button onClick={handleTopUp} className={appStyle.topUpButton}>
                  💾 Top Up Ingestion Storage
                </button>
                <div className={appStyle.topUpInfo}>
                  Get 250,000KB more storage for ₹1500 (~₹0.006 per KB)
                </div>
              </div>
            )}

            {remainingPercentage < 10 && remaining > 0 && (
              <div className={appStyle.lowCreditsWarning}>
                ⚠️ Running low on storage! Only {remaining.toLocaleString()}KB remaining ({Math.round(remainingPercentage)}% left). Top up now to continue ingesting data.
              </div>
            )}

            {remaining <= 0 && (
              <div className={appStyle.criticalWarning}>
                🚨 Out of storage space! Please top up immediately.
              </div>
            )}
          </div>
        )}
      </div>

      {showTopUpModal && (
        <div className={appStyle.modalOverlay} onClick={() => setShowTopUpModal(false)}>
          <div className={appStyle.modalContent} onClick={(e) => e.stopPropagation()}>
            <div className={appStyle.modalHeader}>
              <h3>📦 Top Up Ingestion Storage</h3>
              <button className={appStyle.modalClose} onClick={() => setShowTopUpModal(false)}>✕</button>
            </div>
            <div className={appStyle.modalBody}>
              <div className={appStyle.infoNote}>
                <strong>Current Capacity:</strong> {remaining.toLocaleString()} KB available<br />
                <strong>After Top-up:</strong> {remaining + topUpSize} KB available<br />
                <strong>Total Capacity:</strong> {totalCapacity + topUpSize} KB (Plan: {limit} + Top-ups: {totalTopups + topUpSize})
              </div>
              <div className={appStyle.topUpOptions}>
                <div className={appStyle.topUpOption}>
                  <div className={appStyle.optionPrice}>₹1500</div>
                  <div className={appStyle.optionMessages}>+250,000KB Storage</div>
                  <div className={appStyle.optionPerMessage}>~₹0.006 per KB</div>
                  <button className={appStyle.optionButton} onClick={() => { setTopUpAmount(1500); setTopUpSize(250000); }}>Select</button>
                </div>
                <div className={appStyle.topUpOption}>
                  <div className={appStyle.optionPrice}>₹3000</div>
                  <div className={appStyle.optionMessages}>+500,000KB Storage</div>
                  <div className={appStyle.optionPerMessage}>~₹0.006 per KB</div>
                  <button className={appStyle.optionButton} onClick={() => { setTopUpAmount(3000); setTopUpSize(500000); }}>Select</button>
                </div>
                <div className={appStyle.topUpOption}>
                  <div className={appStyle.optionPrice}>₹4500</div>
                  <div className={appStyle.optionMessages}>+750,000KB Storage</div>
                  <div className={appStyle.optionPerMessage}>~₹0.006 per KB</div>
                  <button className={appStyle.optionButton} onClick={() => { setTopUpAmount(4500); setTopUpSize(750000); }}>Select</button>
                </div>
              </div>
              <div className={appStyle.checkoutContainer}>
                <RazorpayCheckout cost={topUpAmount} planName={`Top Up - ${topUpSize.toLocaleString()}KB Storage`} planCode="INGESTION_TOPUP" userLimit={null} appliedPromo={null} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}